<template>
  <div
    class="grid grid-cols-1 lg:grid-cols-[1fr_2fr] w-[100%] h-[100%] h-full w-full overflow-auto [border-radius:calc(25px-2vh)]"
  >
    <div class="items-center lg:justify-end flex">
      <div
        class="relative w-full md:w-fit align-middle mx-auto mb-[2.5vh] md:p-[2vh] grid grid-rows-2 [border-radius:calc(25px-2vh)] bg-white/70 backdrop-blur-xl shadow-lg lg:-mr-[8vw] flex z-10"
      >
        <div
          id="email"
          class="p-4 text-lg font-bold items-center justify-center flex"
        >
          cenk@hangumrukleme.com.tr
        </div>
        <div
          id="tel"
          class="p-4 text-lg font-bold items-center justify-center flex"
        >
          (+90) 543 211 3454
        </div>
      </div>
    </div>
    <div class="items-center lg:justify-start flex">
      <div
        class="relative grid lg:grid-cols-[2fr_5fr] overflow-hidden w-full lg:w-[70%] lg:h-[90%] bg-[#0A5491] [border-radius:calc(25px-2vh)] shadow-2xl flex lg:-mr-[6vw] shadow-lg"
      >
        <img
          :src="contactIMG"
          alt="Contact"
          class="object-cover w-full h-full"
        />
        <div class="flex justify-center items-center flex-col p-8">
          <form
            class="w-full max-w-lg space-y-4"
            action="MAILTO:örnek@mailiniz.com"
            method="POST"
            enctype="text/plain"
          >
            <div>
              <label
                for="name"
                class="block text-white text-sm font-medium mb-1"
                >Adınız Soyadınız</label
              >
              <input
                type="text"
                id="name"
                name="Ad_Soyad"
                placeholder="Adınızı girin"
                required
                class="w-full p-3 border border-gray-300 rounded-lg focus:ring-indigo-500 focus:border-indigo-500 text-gray-900"
              />
            </div>

            <div>
              <label
                for="email"
                class="block text-white text-sm font-medium mb-1"
                >E-posta Adresiniz</label
              >
              <input
                type="email"
                id="email"
                name="Eposta"
                placeholder="ornek@alanadi.com"
                required
                class="w-full p-3 border border-gray-300 rounded-lg focus:ring-indigo-500 focus:border-indigo-500 text-gray-900"
              />
            </div>

            <div>
              <label
                for="message"
                class="block text-white text-sm font-medium mb-1"
                >Mesajınız</label
              >
              <textarea
                id="message"
                name="Mesaj"
                rows="4"
                placeholder="Bize ne söylemek istersiniz?"
                required
                class="w-full p-3 border border-gray-300 rounded-lg focus:ring-indigo-500 focus:border-indigo-500 text-gray-900 resize-none"
              ></textarea>
            </div>

            <button
              type="submit"
              class="w-full py-3 px-4 bg-yellow-400 text-gray-900 font-bold rounded-lg hover:bg-yellow-500 transition duration-200 focus:outline-none focus:ring-4 focus:ring-yellow-300"
            >
              Gönder
            </button>
          </form>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import contactIMG from '../assets/contact.jpg'
export default {
  name: 'ContactView',
  data() {
    return {
      contactIMG,
    }
  },
}
</script>
